"use strict";

var _interopRequireDefault = require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.awsUpload = awsUpload;
exports.buildHtmlFormData = buildHtmlFormData;
exports.ufileUpload = ufileUpload;
exports.upload = upload;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.function.name");
var _request = _interopRequireDefault(require("@/utils/request"));
function upload(data) {
  return (0, _request.default)({
    url: 'cms/picture/upload',
    method: 'post',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data,
    timeout: 3600000
  });
}
//aws上传
function awsUpload(data) {
  return (0, _request.default)({
    url: 'base/picture/aws/upload',
    method: 'post',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data,
    timeout: 3600000
  });
}
//ufile图片上传接口
function ufileUpload(data) {
  return (0, _request.default)({
    url: 'base/picture/upload',
    method: 'post',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data,
    timeout: 3600000
  });
}

/**
 * 将 HTML 包装为 text/html 再上传，避免 OSS/S3 存成 application/octet-stream 导致浏览器下载而非打开
 */
function buildHtmlFormData(file) {
  var rawName = file && file.name || 'article.html';
  var fileName = /\.html?$/i.test(rawName) ? rawName.replace(/\.htm$/i, '.html') : "".concat(rawName, ".html");
  var blob = new Blob([file], {
    type: 'text/html'
  });
  var fd = new FormData();
  fd.append('file', blob, fileName);
  return {
    formData: fd,
    fileName: fileName
  };
}